var manual =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  wires: __webpack_require__(2),
	  button: __webpack_require__(3),
	  keypad: __webpack_require__(5),
	  onFirst: __webpack_require__(6),
	  simon: __webpack_require__(7),
	  memory: __webpack_require__(8),
	  morse: __webpack_require__(9),
	  complicatedWires: __webpack_require__(10),
	  wireSequences: __webpack_require__(11),
	  maze: __webpack_require__(12),
	  passwords: __webpack_require__(15),
	  knobs: __webpack_require__(16)
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	var numberOfWires = function numberOfWires(colors, color) {
	  var num = 0;
	  colors.forEach(function (c) {
	    return c === color && num++;
	  });
	  return num;
	};
	
	var lastColor = function lastColor(colors) {
	  return colors[colors.length - 1];
	};
	
	var three = function three(colors) {
	  // if there are no red wires, cut the second wire.
	  if (colors.indexOf("r") === -1) {
	    return "cut the second wire";
	  }
	  // if the last wire is white, cut the last wire.
	  if (lastColor(colors) === "w") {
	    return "cut the last wire";
	  }
	  // if there is more than one blue wire, cut the last blue wire.
	  if (numberOfWires(colors, "b") > 1) {
	    return "cut the last blue wire";
	  }
	  // cut the last wire.
	  return "cut the last wire";
	};
	
	var four = function four(colors, isOdd) {
	  var numRedWires = numberOfWires(colors, "r");
	  // if there is more than one red wire and the last digit of the serial number
	  // is odd, cut the last red wire.
	  if (numRedWires > 1 && isOdd) {
	    return "cut the last red wire";
	  }
	  // if the last wire is yellow and there are no red wires, cut the first wire
	  // or if there is exactly one blue wire.
	  if (lastColor(colors) === "y" && numRedWires === 0 || numberOfWires(colors, "b") === 1) {
	    return "cut the first wire";
	  }
	  // if there is more than one yellow wire, cut the last wire.
	  if (numberOfWires(colors, "y" > 1)) {
	    return "cut the last wire";
	  }
	  // cut the second wire.
	  return "cut the second wire";
	};
	
	var five = function five(colors, isOdd) {
	  // if the last wire is black and the last digit of the serial number is odd, cut the fourth wire.
	  if (lastColor(colors) === "k" && isOdd) {
	    return "cut the fourth wire";
	  }
	  // if there is exactly one red wire and there is more than one yellow wire, cut the first wire.
	  if (numberOfWires(colors, "r") === 1 && numberOfWires(colors, "y" > 1)) {
	    return "cut the first wire";
	  }
	  // if there are no black wires, cut the second wire.
	  if (numberOfWires(colors, "k") === 0) {
	    return "cut the second wire";
	  }
	  // cut the first wire.
	  return "cut the first wire";
	};
	
	var six = function six(colors, isOdd) {
	  // if there are no yellow wires and the last digit of the serial number is odd, cut the third wire.
	  if (numberOfWires(colors, "y") === 0 && isOdd) {
	    return "cut the third wire";
	  }
	  // if there is exactly one yellow wire and there is more than one white wire, cut the fourth wire.
	  if (numberOfWires(colors, "y") === 1 && numberOfWires(colors, "w" > 1)) {
	    return "cut the fourth wire";
	  }
	  // if there are no red wires, cut the last wire.
	  if (numberOfWires(colors, "r") === 0) {
	    return "cut the last wire";
	  }
	  // cut the fourth wire.
	  return "cut the fourth wire";
	};
	
	var cutWire = function cutWire(colorsStr, isOdd) {
	  var colors = colorsStr.split("");
	  switch (colors.length) {
	    case 3:
	      return three(colors);
	    case 4:
	      return four(colors, isOdd);
	    case 5:
	      return five(colors, isOdd);
	    case 6:
	      return six(colors, isOdd);
	    default:
	      return "incorrect number of wires";
	  }
	};
	
	module.exports = {
	  cut: cutWire
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(4);
	
	var holdInstructions = function holdInstructions(color) {
	  if (color === constants.BLUE) {
	    return 4;
	  }
	  if (color === constants.YELLOW) {
	    return 5;
	  }
	  return 1;
	};
	
	var pressButton = function pressButton(color, word, numBatteries, frk) {
	  //if the button is blue and the button says "Abort", hold the button and
	  //refer to "Releasing a Held Button".
	  if (color === constants.BLUE && word === "abort") {
	    return constants.HOLD;
	  }
	  //if there is more than 1 battery on the bomb and the button says "Detonate",
	  //press and immediately release the button.
	  if (numBatteries > 1 && word === "detonate") {
	    return constants.IMMEDIATE;
	  }
	  //if the button is yellow or white or there are more than 2 batteries on the
	  //bomb and there is a lit indicator with label FRK, press and immediately
	  //release the button.
	  if (color === constants.WHITE || color === constants.YELLOW || numBatteries > 2 && frk === constants.YES) {
	    return constants.HOLD;
	  }
	  // if we don't know about batteries or lit indicator then ask
	  if (numBatteries === -1 && frk === constants.YES || !frk && numBatteries > 2 || numBatteries === -1 && !frk) {
	    return constants.INDETERMINATE;
	  }
	  //if the button is red and the button says "Hold", press and immediately
	  //release the button.
	  if (color === constants.RED && word === "hold") {
	    return constants.IMMEDIATE;
	  }
	  //if none of the above apply, hold the button and refer to "Releasing a Held
	  //Button".
	  return constants.HOLD;
	};
	
	module.exports = {
	  press: pressButton,
	  hold: holdInstructions
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  HOLD: "h",
	  IMMEDIATE: "i",
	  INDETERMINATE: "?",
	  WHITE: "w",
	  RED: "r",
	  BLUE: "b",
	  BLACK: "k",
	  YELLOW: "y",
	  GREEN: "g",
	  YES: "y",
	  NO: "n"
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	// 1: balloon
	// 2: a with t
	// 3: upside down y
	// 4: harry potter
	// 5: amazon warrior
	// 6: h with tail
	// 7: backward c
	// 8: backward e
	// 9: pig tail
	// 10: empty star
	// 11: upside down ?
	// 12: copyright
	// 13: butt chin
	// 14: back to back k
	// 15: half of an r
	// 16: six
	// 17: music note
	// 18: b with t
	// 19: smiley face
	// 20: pitch fork
	// 21: c
	// 22: snake with antlers
	// 23: filled in star
	// 24: train tracks
	// 25: ae
	// 26: backward n
	// 27: omega
	
	var options = [[1, 2, 3, 4, 5, 6, 7], [8, 1, 7, 9, 10, 6, 11], [12, 13, 9, 14, 15, 3, 10], [16, 17, 18, 5, 14, 11, 19], [20, 19, 18, 21, 17, 22, 23], [16, 8, 24, 25, 20, 26, 27]];
	
	var has = function has(key, option) {
	  return option.find(function (num) {
	    return num === parseInt(key);
	  });
	};
	
	var getIndexes = function getIndexes(option, one, two, three, four) {
	  var answer = [option.indexOf(parseInt(one)), option.indexOf(parseInt(two)), option.indexOf(parseInt(three)), option.indexOf(parseInt(four))].sort();
	  return [option[answer[0]], option[answer[1]], option[answer[2]], option[answer[3]]];
	};
	
	var findKeys = function findKeys(one, two, three, four) {
	  var option = options.filter(function (col) {
	    return has(one, col) && has(two, col) && has(three, col) && has(four, col);
	  })[0];
	  return getIndexes(option, one, two, three, four);
	};
	
	module.exports = {
	  find: findKeys
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	var positions = {
	  "yes": ["middle", "left"],
	  "first": ["top", "right"],
	  "display": ["bottom", "right"],
	  "okay": ["top", "right"],
	  "says": ["bottom", "right"],
	  "nothing": ["middle", "left"],
	  "": ["bottom", "left"],
	  "blank": ["middle", "right"],
	  "no": ["bottom", "right"],
	  "led": ["middle", "left"],
	  "lead": ["bottom", "right"],
	  "read": ["middle", "right"],
	  "red": ["middle", "right"],
	  "reed": ["bottom", "left"],
	  "leed": ["bottom", "left"],
	  "hold on": ["bottom", "right"],
	  "you": ["middle", "right"],
	  "you are": ["bottom", "right"],
	  "your": ["top", "right"],
	  "you're": ["top", "right"],
	  "ur": ["top", "left"],
	  "there": ["bottom", "right"],
	  "they're": ["bottom", "left"],
	  "their": ["top", "right"],
	  "they are": ["middle", "left"],
	  "see": ["bottom", "right"],
	  "c": ["top", "right"],
	  "cee": ["bottom", "right"]
	};
	
	var words = {
	  "READY": "YES, OKAY, WHAT, MIDDLE, LEFT, PRESS, RIGHT, BLANK, READY",
	  "FIRST": "LEFT, OKAY, YES, MIDDLE, NO, RIGHT, NOTHING, UHHH, WAIT, READY, BLANK, WHAT, PRESS, FIRST",
	  "NO": "BLANK, UHHH, WAIT, FIRST, WHAT, READY, RIGHT, YES, NOTHING, LEFT, PRESS, OKAY, NO",
	  "BLANK": "WAIT, RIGHT, OKAY, MIDDLE, BLANK",
	  "NOTHING": "UHHH, RIGHT, OKAY, MIDDLE, YES, BLANK, NO, PRESS, LEFT, WHAT, WAIT, FIRST, NOTHING",
	  "YES": "OKAY, RIGHT, UHHH, MIDDLE, FIRST, WHAT, PRESS, READY, NOTHING, YES",
	  "WHAT": "UHHH, WHAT",
	  "UHHH": "READY, NOTHING, LEFT, WHAT, OKAY, YES, RIGHT, NO, PRESS, BLANK, UHHH",
	  "LEFT": "RIGHT, LEFT",
	  "RIGHT": "YES, NOTHING, READY, PRESS, NO, WAIT, WHAT, RIGHT",
	  "MIDDLE": "BLANK, READY, OKAY, WHAT, NOTHING, PRESS, NO, WAIT, LEFT, MIDDLE",
	  "OKAY": "MIDDLE, NO, FIRST, YES, UHHH, NOTHING, WAIT, OKAY",
	  "WAIT": "UHHH, NO, BLANK, OKAY, YES, LEFT, FIRST, PRESS, WHAT, WAIT",
	  "PRESS": "RIGHT, MIDDLE, YES, READY, PRESS",
	  "YOU": "SURE, YOU ARE, YOUR, YOU'RE, NEXT, UH HUH, UR, HOLD, WHAT?, YOU",
	  "YOU ARE": "YOUR, NEXT, LIKE, UH HUH, WHAT?, DONE, UH UH, HOLD, YOU, U, YOU'RE, SURE, UR, YOU ARE",
	  "YOUR": "UH UH, YOU ARE, UH HUH, YOUR",
	  "YOU'RE": "YOU, YOU'RE",
	  "UR": "DONE, U, UR",
	  "U": "UH HUH, SURE, NEXT, WHAT?, YOU'RE, UR, UH UH, DONE, U",
	  "UH HUH": "UH HUH",
	  "UH UH": "UR, U, YOU ARE, YOU'RE, NEXT, UH UH",
	  "WHAT?": "YOU, HOLD, YOU'RE, YOUR, U, DONE, UH UH, LIKE, YOU ARE, UH HUH, UR, NEXT, WHAT?",
	  "DONE": "SURE, UH HUH, NEXT, WHAT?, YOUR, UR, YOU'RE, HOLD, LIKE, YOU, U, YOU ARE, UH UH, DONE",
	  "NEXT": "WHAT?, UH HUH, UH UH, YOUR, HOLD, SURE, NEXT",
	  "HOLD": "YOU ARE, U, DONE, UH UH, YOU, UR, SURE, WHAT?, YOU'RE, NEXT, HOLD",
	  "SURE": "YOU ARE, DONE, LIKE, YOU'RE, YOU, HOLD, UH HUH, UR, SURE",
	  "LIKE": "YOU'RE, NEXT, U, UR, HOLD, DONE, UH UH, WHAT?, UH HUH, YOU, LIKE"
	};
	
	var findPosition = function findPosition(word) {
	  return positions[word];
	};
	
	var getWords = function getWords(word) {
	  return words[word];
	};
	
	module.exports = {
	  findPosition: findPosition,
	  getWords: getWords
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(4);
	
	var buildObject = function buildObject(a, b) {
	  var obj = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  obj[a] = b;
	  return obj;
	};
	
	var buildConversions = function buildConversions() {
	  var noStrikes = buildObject(constants.RED, constants.BLUE);
	  buildObject(constants.BLUE, constants.RED, noStrikes);
	  buildObject(constants.GREEN, constants.YELLOW, noStrikes);
	  buildObject(constants.YELLOW, constants.GREEN, noStrikes);
	
	  var oneStrikes = buildObject(constants.RED, constants.YELLOW);
	  buildObject(constants.BLUE, constants.GREEN, oneStrikes);
	  buildObject(constants.GREEN, constants.BLUE, oneStrikes);
	  buildObject(constants.YELLOW, constants.RED, oneStrikes);
	
	  var twoStrikes = buildObject(constants.RED, constants.GREEN);
	  buildObject(constants.BLUE, constants.RED, twoStrikes);
	  buildObject(constants.GREEN, constants.YELLOW, twoStrikes);
	  buildObject(constants.YELLOW, constants.BLUE, twoStrikes);
	
	  var containsVowel = [noStrikes, oneStrikes, twoStrikes];
	
	  noStrikes = buildObject(constants.RED, constants.BLUE);
	  buildObject(constants.BLUE, constants.YELLOW, noStrikes);
	  buildObject(constants.GREEN, constants.GREEN, noStrikes);
	  buildObject(constants.YELLOW, constants.RED, noStrikes);
	
	  oneStrikes = buildObject(constants.RED, constants.RED);
	  buildObject(constants.BLUE, constants.BLUE, oneStrikes);
	  buildObject(constants.GREEN, constants.YELLOW, oneStrikes);
	  buildObject(constants.YELLOW, constants.GREEN, oneStrikes);
	
	  twoStrikes = buildObject(constants.RED, constants.YELLOW);
	  buildObject(constants.BLUE, constants.GREEN, twoStrikes);
	  buildObject(constants.GREEN, constants.BLUE, twoStrikes);
	  buildObject(constants.YELLOW, constants.RED, twoStrikes);
	
	  var noVowel = [noStrikes, oneStrikes, twoStrikes];
	
	  return { "true": containsVowel, "false": noVowel };
	};
	
	var says = function says(strikes, serialHasVowel, color) {
	  var conversions = buildConversions();
	  return conversions[String(serialHasVowel)][strikes][color];
	};
	
	module.exports = {
	  says: says
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	//rounds = [
	//  {
	//    "number": 2,
	//    "position": 3,
	//  },
	//  ...
	//]
	
	var firstRound = function firstRound(display) {
	  return { "position": Math.max(2, parseInt(display)) };
	};
	
	var secondRound = function secondRound(display, rounds) {
	  if (display == 1) {
	    return { "label": 4 };
	  }
	  if (display == 2 || display == 4) {
	    return { "position": rounds[0].position };
	  }
	  if (display == 3) {
	    return { "position": 1 };
	  }
	};
	
	var thirdRound = function thirdRound(display, rounds) {
	  if (display == 1) {
	    return { "label": rounds[1].label };
	  }
	  if (display == 2) {
	    return { "label": rounds[0].label };
	  }
	  if (display == 3) {
	    return { "position": 3 };
	  }
	  if (display == 4) {
	    return { "label": 4 };
	  }
	};
	
	var fourthRound = function fourthRound(display, rounds) {
	  if (display == 1) {
	    return { "position": rounds[0].position };
	  }
	  if (display == 2) {
	    return { "position": 1 };
	  }
	  if (display == 3 || display == 4) {
	    return { "position": rounds[1].position };
	  }
	};
	
	var fifthRound = function fifthRound(display, rounds) {
	  if (display == 1) {
	    return { "label": rounds[0].label };
	  }
	  if (display == 2) {
	    return { "label": rounds[1].label };
	  }
	  if (display == 3) {
	    return { "label": rounds[3].label };
	  }
	  if (display == 4) {
	    return { "label": rounds[2].label };
	  }
	};
	
	var roundFuncs = [firstRound, secondRound, thirdRound, fourthRound, fifthRound];
	
	var rounds = void 0;
	
	var init = function init() {
	  rounds = [];
	};
	
	var getNumber = function getNumber(display) {
	  var answer = roundFuncs[rounds.length](display, rounds);
	
	  for (var _len = arguments.length, numbers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    numbers[_key - 1] = arguments[_key];
	  }
	
	  if (answer.position) {
	    answer.label = numbers[answer.position - 1];
	  } else if (answer.label) {
	    answer.position = numbers.indexOf(answer.label) + 1;
	  }
	  rounds.push(answer);
	  return answer.label;
	};
	
	module.exports = {
	  init: init,
	  getNumber: getNumber
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	var alphabetToMorseMap = {
	  "a": ".-",
	  "b": "-...",
	  "c": "-.-.",
	  "d": "-..",
	  "e": ".",
	  "f": "..-.",
	  "g": "--.",
	  "h": "....",
	  "i": "..",
	  "j": ".---",
	  "k": "-.-",
	  "l": ".-..",
	  "m": "--",
	  "n": "-.",
	  "o": "---",
	  "p": ".--.",
	  "q": "--.-",
	  "r": ".-.",
	  "s": "...",
	  "t": "-",
	  "u": "..-",
	  "v": "...-",
	  "w": ".--",
	  "x": "-..-",
	  "y": "-.--",
	  "z": "--..",
	  "1": ".----",
	  "2": "..---",
	  "3": "...--",
	  "4": "....-",
	  "5": ".....",
	  "6": "-....",
	  "7": "--...",
	  "8": "---..",
	  "9": "----.",
	  "0": "-----"
	};
	
	var wordToFrequencyMap = {
	  "shell": "3.505 MHz",
	  "halls": "3.515 MHz",
	  "slick": "3.522 MHz",
	  "trick": "3.532 MHz",
	  "boxes": "3.535 MHz",
	  "leaks": "3.542 MHz",
	  "strobe": "3.545 MHz",
	  "bistro": "3.552 MHz",
	  "flick": "3.555 MHz",
	  "bombs": "3.565 MHz",
	  "break": "3.572 MHz",
	  "brick": "3.575 MHz",
	  "steak": "3.582 MHz",
	  "sting": "3.592 MHz",
	  "vector": "3.595 MHz",
	  "beats": "3.600 MHz"
	};
	
	// no spaces in between letters
	var morsify = function morsify(words) {
	  var morseToWords = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = words[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var word = _step.value;
	
	      var letters = word.split("");
	      var morseLetters = [];
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = letters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var letter = _step2.value;
	
	          morseLetters.push(alphabetToMorseMap[letter]);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      morseToWords[morseLetters.join("")] = word;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return morseToWords;
	};
	
	var duplicate = function duplicate(morseWords) {
	  var duplicates = {};
	  for (var word in morseWords) {
	    duplicates[word + "b" + word] = morseWords[word];
	  }
	  return duplicates;
	};
	
	var findMatch = function findMatch(wordsMap, flashes) {
	  var morseWords = Object.keys(wordsMap);
	  var matches = [];
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = morseWords[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var word = _step3.value;
	
	      if (word.includes(flashes)) {
	        matches.push(wordsMap[word]);
	      }
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	
	  return matches;
	};
	
	var createFrequenciesString = function createFrequenciesString(words) {
	  var frequencies = [];
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    for (var _iterator4 = words[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      var word = _step4.value;
	
	      frequencies.push(word + ": " + wordToFrequencyMap[word]);
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4.return) {
	        _iterator4.return();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	
	  return frequencies.join("\n");
	};
	
	// assuming that letters contain a 'b' for the break between instances of the
	// word
	
	var interpret = function interpret(flashes) {
	  var words = Object.keys(wordToFrequencyMap);
	  var morseWords = duplicate(morsify(words));
	  var matches = findMatch(morseWords, flashes);
	  if (matches.length === 0) {
	    return "no matches found";
	  }
	  return createFrequenciesString(matches);
	};
	
	module.exports = {
	  interpret: interpret
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(4);
	
	// solutions: led, colors, star (e.g. 1r0 = has led, color is red and no star)
	
	var solutions = {
	  "0w0": "c",
	  "0w1": "c",
	  "1w0": "d",
	  "1w1": "b",
	  "0r0": "s",
	  "0r1": "c",
	  "1r0": "b",
	  "1r1": "b",
	  "0b0": "s",
	  "0b1": "d",
	  "1b0": "p",
	  "1b1": "p",
	  "0br0": "s",
	  "0br1": "p",
	  "1br0": "s",
	  "1br1": "d"
	};
	
	var normalizeColors = function normalizeColors(colors) {
	  var hasRed = colors.includes(constants.RED);
	  var hasBlue = colors.includes(constants.BLUE);
	  if (hasRed && hasBlue) {
	    return constants.BLUE + constants.RED;
	  }
	  if (hasRed) {
	    return "r";
	  }
	  if (hasBlue) {
	    return "b";
	  }
	  return "w";
	};
	
	var boolToInt = function boolToInt(boolean) {
	  return boolean ? 1 : 0;
	};
	
	var shouldCut = function shouldCut(led, colors, star) {
	  colors = normalizeColors(colors);
	  var solution = solutions['' + boolToInt(led) + colors + boolToInt(star)];
	  return solution;
	};
	
	module.exports = {
	  shouldCut: shouldCut
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	//colors = {
	//  "k": 2,
	//  "r": 3,
	//  "b": 5,
	//};
	
	var redInstructions = [["c"], ["b"], ["a"], ["a", "c"], ["b"], ["a", "c"], ["a", "b", "c"], ["a", "b"], ["b"]];
	
	var blueInstructions = [["b"], ["a", "c"], ["b"], ["a"], ["b"], ["b", "c"], ["c"], ["a", "c"], ["a"]];
	
	var blackInstructions = [["a", "b", "c"], ["a", "c"], ["b"], ["a", "c"], ["b"], ["b", "c"], ["a", "b"], ["c"]];
	
	var instructions = {
	  "r": redInstructions,
	  "b": blueInstructions,
	  "k": blackInstructions
	};
	
	var colors = void 0;
	
	var init = function init() {
	  colors = {
	    "r": 0,
	    "b": 0,
	    "k": 0
	  };
	};
	
	var shouldCut = function shouldCut(color, letter) {
	  var should = instructions[color][colors[color]].indexOf(letter) !== -1;
	  colors[color]++;
	  return should;
	};
	
	module.exports = {
	  init: init,
	  shouldCut: shouldCut
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var mazeData = __webpack_require__(14);
	
	// [
	// [ 0, 0, 0, 0, 0, 0 ],
	// ...
	// ]
	
	var COLS = 6,
	    ROWS = 6,
	    UP = 0x1,
	    RIGHT = 0x2,
	    DOWN = 0x4,
	    LEFT = 0x8;
	
	var initializeMaze = function initializeMaze(rows, cols) {
	  var maze = [];
	  for (var i = 0; i < rows; i++) {
	    maze.push(Array(cols).fill(0));
	  }
	  return maze;
	};
	
	var parseMazes = function parseMazes(mazeData) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = mazeData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var mazeObj = _step.value;
	
	      var maze = initializeMaze(ROWS, COLS);
	      var lines = mazeObj.mazeData.split("\n");
	      lines.shift();
	      for (var y = 0; y < ROWS; y++) {
	        for (var x = 0; x < COLS; x++) {
	          if (lines[y][x * 2 + 1] !== " ") {
	            maze[x][y] |= UP;
	          }
	          if (lines[y + 1][x * 2] === "|") {
	            maze[x][y] |= LEFT;
	          }
	          if (lines[y + 1][x * 2 + 1] !== " ") {
	            maze[x][y] |= DOWN;
	          }
	          if (lines[y + 1][x * 2 + 2] === "|") {
	            maze[x][y] |= RIGHT;
	          }
	        }
	      }
	      mazeObj.maze = maze;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};
	
	var printMaze = function printMaze(maze) {
	  console.log(".___________.");
	  for (var y = 0; y < ROWS; y++) {
	    process.stdout.write("|");
	    for (var x = 0; x < COLS; x++) {
	      if ((maze[x][y] & DOWN) !== 0) {
	        process.stdout.write("_");
	      } else {
	        process.stdout.write(" ");
	      }
	      if ((maze[x][y] & RIGHT) !== 0) {
	        process.stdout.write("|");
	      } else {
	        process.stdout.write(".");
	      }
	    }
	    process.stdout.write('\n');
	  }
	};
	
	var coordsEqual = function coordsEqual(first, second) {
	  return first[0] === second[0] && first[1] === second[1];
	};
	
	var translate = function translate(coord, direction) {
	  if (direction === LEFT) {
	    return [coord[0] - 1, coord[1]];
	  }
	  if (direction === UP) {
	    return [coord[0], coord[1] - 1];
	  }
	  if (direction === RIGHT) {
	    return [coord[0] + 1, coord[1]];
	  }
	  if (direction === DOWN) {
	    return [coord[0], coord[1] + 1];
	  }
	};
	
	// array of coords
	var traverseMaze = function traverseMaze(maze, start, end, entered) {
	  if (coordsEqual(start, end)) {
	    return [start];
	  }
	  var cur = maze[start[0]][start[1]];
	  var _arr = [UP, DOWN, LEFT, RIGHT];
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var direction = _arr[_i];
	    if ((cur & direction) === 0 && !coordsEqual(entered, translate(start, direction))) {
	      var foundCoords = traverseMaze(maze, translate(start, direction), end, start);
	      if (foundCoords) {
	        foundCoords.unshift(start);
	        return foundCoords;
	      }
	    }
	  }
	  return false;
	};
	
	var convertCoord = function convertCoord(coord) {
	  return translate(translate(coord, LEFT), UP);
	};
	
	var getPath = function getPath(circle, start, end) {
	  var maze = mazeData.find(function (m) {
	    return m.coords.some(function (coord) {
	      return coordsEqual(coord, circle);
	    });
	  });
	  return traverseMaze(maze.maze, convertCoord(start), convertCoord(end), [-1, -1]);
	};
	
	parseMazes(mazeData);
	
	module.exports = {
	  getPath: getPath
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 13 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = [{
	  "coords": [[1, 2], [6, 3]],
	  "mazeData": "\n.___________.\n| ._. | .___|\n| | ._|___. |\n| |_. | ._. |\n| |_____|_. |\n| ._. | ._| |\n|___|___|___|\n" }, {
	  "coords": [[2, 4], [5, 2]],
	  "mazeData": "\n.___________.\n|_. ._|   ._|\n| ._| ._|_. |\n| | ._| ._. |\n| ._| ._| | |\n| | | | ._| |\n|_|___|_____|\n" }, {
	  "coords": [[4, 4], [6, 4]],
	  "mazeData": "\n.___________.\n| ._. | | . |\n|_| | |___| |\n| . | | . | |\n| | | | | | |\n| |___| | | |\n|_______|___|\n" }, {
	  "coords": [[1, 1], [1, 4]],
	  "mazeData": "\n.___________.\n| . |_____. |\n| | | .___. |\n| |___| ._| |\n| |_______. |\n| ._____. | |\n|_____|___|_|\n" }, {
	  "coords": [[4, 6], [5, 3]],
	  "mazeData": "\n.___________.\n|_______. . |\n| .___. ._|_|\n| . |___| . |\n| |___. |_| |\n| | ._____| |\n|_|_________|\n" }, {
	  "coords": [[3, 5], [5, 1]],
	  "mazeData": "\n.___________.\n| | . |_. . |\n| | | | ._| |\n| ._|_| | ._|\n|_. | . | | |\n| ._|_| |_. |\n|_______|___|\n" }, {
	  "coords": [[2, 1], [2, 6]],
	  "mazeData": "\n.___________.\n| .___. | . |\n| | ._|___| |\n|___| ._| ._|\n| . | .___| |\n| |_|___. | |\n|___________|\n" }, {
	  "coords": [[3, 4], [4, 1]],
	  "mazeData": "\n.___________.\n| | ._. | . |\n| .___|___| |\n| | .___. | |\n| |_. |_____|\n| | |_______|\n|___________|\n" }, {
	  "coords": [[1, 5], [3, 2]],
	  "mazeData": "\n.___________.\n| | .___. . |\n| | | ._| | |\n| .___| ._| |\n| | | ._|_. |\n| | | | . |_|\n|___|___|___|\n" }];

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	var passwords = ["about", "after", "again", "below", "could", "every", "first", "found", "great", "house", "large", "learn", "never", "other", "place", "plant", "point", "right", "small", "sound", "spell", "still", "study", "their", "there", "these", "thing", "think", "three", "water", "where", "which", "world", "would", "write"];
	
	var crack = function crack(first, last) {
	  var words = [];
	  passwords.forEach(function (word) {
	    if (first.indexOf(word[0]) !== -1 && last.indexOf(word[word.length - 1]) !== -1) {
	      words.push(word);
	    }
	  });
	  return words;
	};
	
	module.exports = {
	  crack: crack
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	var getPosition = function getPosition(four, five) {
	  if (four[0] === 0 && four[1] === 1 && five[0] === 1 && five[1] === 0) {
	    return "UP";
	  }
	  if (four[0] === 0 && four[1] === 0 && five[0] === 1 && five[1] === 1) {
	    return "UP";
	  }
	  if (four[0] === 0 && four[1] === 1 && five[0] === 0 && five[1] === 0) {
	    return "DOWN";
	  }
	  if (four[0] === 0 && four[1] === 0 && five[0] === 1 && five[1] === 0) {
	    return "DOWN";
	  }
	  if (four[0] === 0 && four[1] === 1 && five[0] === 1 && five[1] === 1) {
	    return "LEFT";
	  }
	  if (four[0] === 1 && four[1] === 0 && five[0] === 1 && five[1] === 1) {
	    return "RIGHT";
	  }
	  if (four[0] === 1 && four[1] === 0 && five[0] === 0 && five[1] === 1) {
	    return "RIGHT";
	  }
	};
	
	module.exports = {
	  getPosition: getPosition
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** manual.js
 **/